import React, { ComponentType, useContext } from 'react';
import { ObjectFieldTemplateProps } from '@rjsf/utils';
import { getDefaultRegistry } from '@rjsf/core';
import { RowLayoutContext, rowCellClass } from './rowLayout';

// Looked up on first render, not at import: suites that mock @rjsf/core
// still import SchemaForm, which registers this template.
let defaultTemplate: ComponentType<ObjectFieldTemplateProps> | undefined;
const getDefaultTemplate = () =>
  (defaultTemplate ??= getDefaultRegistry().templates.ObjectFieldTemplate);

// rjsf's own object template everywhere except the items of a row-layout
// array (see rowLayout.ts), which render their properties as one row of cells
// with no legend: the list's caption line names the columns.
const RowAwareObjectFieldTemplate = (props: ObjectFieldTemplateProps) => {
  const role = useContext(RowLayoutContext);
  if (role !== 'item') {
    const DefaultObjectFieldTemplate = getDefaultTemplate();
    return <DefaultObjectFieldTemplate {...props} />;
  }
  const visible = props.properties.filter((property) => !property.hidden);
  return (
    <div
      className="flex w-full flex-col gap-2 sm:flex-row sm:items-start"
      data-testid="RowObjectFieldTemplate-row"
    >
      {props.properties.map((property) =>
        property.hidden ? (
          <RowLayoutContext.Provider key={property.name} value={null}>
            {property.content}
          </RowLayoutContext.Provider>
        ) : (
          <div
            key={property.name}
            className={rowCellClass(visible.indexOf(property), visible.length)}
            data-testid="RowObjectFieldTemplate-cell"
          >
            <RowLayoutContext.Provider value="cell">
              {property.content}
            </RowLayoutContext.Provider>
          </div>
        ),
      )}
    </div>
  );
};

export default RowAwareObjectFieldTemplate;
